import { FC } from 'react';

import {
  ControlsPanelIcon,
  ICommonIconProps,
  LinkIcon,
  LockIcon,
  MobilePhoneIcon,
  PaletteIcon,
  ShellIcon,
  TTranslator,
} from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

export const getTabs = (
  t: TTranslator<TLocalesKeys>
): Array<{ Icon: FC<ICommonIconProps>; title: string; id: string }> => {
  return [
    {
      Icon: ControlsPanelIcon,
      title: t('settings.tabs.billing'),
      id: 'billing',
    },
    {
      Icon: ShellIcon,
      title: t('settings.tabs.shell'),
      id: 'shell',
    },
    {
      Icon: LockIcon,
      title: t('settings.tabs.security'),
      id: 'security',
    },
    {
      Icon: PaletteIcon,
      title: t('settings.tab.customization'),
      id: 'customization',
    },
    {
      Icon: MobilePhoneIcon,
      title: 'SmartGamer',
      id: 'smartGamer',
    },
    {
      Icon: LinkIcon,
      title: t('settings.tab.integration'),
      id: 'integrations',
    },
  ];
};
